import * as t from 'io-ts'

const taskInboxViewToNull = {
  Pending: null,
  Inbox: null,
  InProgress: null,
  InReview: null,
  Approved: null,
  Rejected: null,
  Completed: null,
}

const inboxViewToNull = {
  Pending: null,
  Inbox: null,
  InProgress: null,
  InReview: null,
  Approved: null,
  Rejected: null,
  Completed: null,
}

export const InboxViewIO = t.keyof(inboxViewToNull)

export type InboxViewT = t.TypeOf<typeof InboxViewIO>

export const TaskInboxViewIO = t.keyof(taskInboxViewToNull)
export type TaskInboxViewT = t.TypeOf<typeof TaskInboxViewIO>

export const TASK_INBOX_VIEWS = Object.keys(
  taskInboxViewToNull,
) as TaskInboxViewT[]

export const isBulkView = (view: InboxViewT) => view === 'InReview' || view === 'Pending'
